import React, { useEffect } from 'react';

import { Select } from '../../../../Select';
import { useTableContext } from '../../../contexts';

import styles from './PageSizePicker.module.scss';

export interface IPageSizePickerProps {}

export const PageSizePicker: React.FC<IPageSizePickerProps> = () => {
    const {
        state: { pagination },
        props: { pageSizeOptions },
        setPagination,
    } = useTableContext();

    const handleChangePageSize = (selectedPageSize: string | number) => {
        const pageSize = Number(selectedPageSize);
        if (isNaN(pageSize)) return;

        setPagination((prev) => ({ ...prev, pageSize, pageIndex: 0 }));
    };

    // Ensure that the current page size is a valid option
    useEffect(() => {
        if (pageSizeOptions.includes(pagination.pageSize)) {
            return;
        }
        setPagination((prev) => ({ ...prev, pageSize: pageSizeOptions[0] }));
    }, [pageSizeOptions, pagination.pageSize, setPagination]);

    return (
        <Select
            size="small"
            value={pagination.pageSize.toString()}
            className={styles.select}
            onValueChange={handleChangePageSize}
            options={pageSizeOptions.map((pageSize) => ({
                value: pageSize.toString(),
                label: pageSize.toString(),
            }))}
        />
    );
};
